import { Component, OnInit, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { BooleanFeatureFlagDirective } from '@openfeature/angular-sdk';
import { SubscribeBlockComponent } from '../subscribe-block/subscribe-block.component';
@Component({
    selector: 'tea-shop-fe-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css'],
    imports: [BooleanFeatureFlagDirective, SubscribeBlockComponent, RouterLink]
})
export class NotFoundComponent implements OnInit {
  private metaDataService = inject(MetaDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);


  originalUrl = '';

  constructor() {
    this.metaDataService.updateMetadata({
      title: 'Page Not Found - Sencha Tea',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
  }

  ngOnInit() {
    const navigation = this.router.currentNavigation();
    if (navigation?.previousNavigation) {
      this.originalUrl = navigation.previousNavigation.finalUrl?.toString() || '';
    } else if (!this.route.snapshot.data['isDirectNavigation']) {
      this.originalUrl = this.router.url;
    } else {
      this.originalUrl = '';
    }
    // TODO : We'll do something with this later like a database lookup for suggestions or logging
  }

}
